(function () {
  const updateTabIndicator = (section, activeTab) => {
    const indicator = section.querySelector('.faq-cottolio__tabs-indicator');
    const tabsNav = section.querySelector('.faq-cottolio__tabs');
    if (!indicator || !activeTab || !tabsNav) return;

    const navRect = tabsNav.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    const offset = tabRect.left - navRect.left + tabsNav.scrollLeft;

    indicator.style.width = tabRect.width + 'px';
    indicator.style.transform = 'translateX(' + offset + 'px)';
  };

  const resetCollapsibleGroup = (section, categoryHandle) => {
    const items = section.querySelectorAll(
      '.collapsible-content__item[data-category-handle="' + categoryHandle + '"]'
    );

    items.forEach(function (item, index) {
      const answer = item.querySelector('.collapsible-content__answer');
      const shouldOpen = index === 0;

      item.classList.toggle('active', shouldOpen);
      if (answer) {
        answer.style.display = shouldOpen ? 'block' : 'none';
      }
    });
  };

  const filterRows = (section, categoryHandle) => {
    section.querySelectorAll('.collapsible-content__item[data-category-handle]').forEach(function (item) {
      const isVisible = item.dataset.categoryHandle === categoryHandle;
      item.style.display = isVisible ? '' : 'none';
    });

    resetCollapsibleGroup(section, categoryHandle);
  };

  const bindTabs = (section) => {
    const tabs = section.querySelectorAll('.faq-cottolio__tab');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const categoryHandle = tab.dataset.categoryHandle;
        if (!categoryHandle || tab.classList.contains('is-active')) return;

        tabs.forEach(function (otherTab) {
          otherTab.classList.remove('is-active');
          otherTab.setAttribute('aria-selected', 'false');
        });

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        filterRows(section, categoryHandle);
        updateTabIndicator(section, tab);

        tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    });

    const activeTab = section.querySelector('.faq-cottolio__tab.is-active') || tabs[0];
    if (activeTab) {
      filterRows(section, activeTab.dataset.categoryHandle);
      updateTabIndicator(section, activeTab);
    }
  };

  const initFaqCottolio = (root) => {
    const sections = root ? [root] : document.querySelectorAll('[data-faq-section]');

    sections.forEach(function (section) {
      if (section.dataset.faqInit === 'true') return;
      section.dataset.faqInit = 'true';
      bindTabs(section);

      window.addEventListener('resize', function () {
        const activeTab = section.querySelector('.faq-cottolio__tab.is-active');
        updateTabIndicator(section, activeTab);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initFaqCottolio();
  });

  document.addEventListener('shopify:section:load', function (event) {
    const section = event.target.querySelector('[data-faq-section]');
    if (section) initFaqCottolio(section);
  });
})();
